/*
  GALERIE — Configurateur « Composez votre intérieur » (Goto).
  Logique reprise de la maquette : compositions (layoutChain), aimantation (snapPos), place libre (freeSpot),
  scène 3D (init3d / buildRoom / buildMods), forme du Goto (gotoGeo, à l'identique), textures, vue de dessus.
  Données : JSON de la section (prix, prix barrés, disponibilité, photos des variantes Shopify).
  three.js n'est chargé qu'au moment où le studio arrive à l'écran ; la boucle de rendu s'arrête hors écran.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-cfg]');
  if (!root) return;
  var DATA;
  try { DATA = JSON.parse(root.querySelector('[data-cfg-json]').textContent); } catch (e) { return; }

  var $ = function (sel) { return root.querySelector(sel); };
  var TX = DATA.texts || {};
  var RW = 5.4, RD = 4.4;
  var TYPES = ['fauteuil', '2p', '3p', 'angle', 'pouf'];
  // Couleurs du tissu (3D) et de la vue de dessus — reprises de la maquette.
  var FAB = { blanc: ['#e2d8c5', '#fff8ea'], gris: ['#a3a29e', '#e4e3df'], noir: ['#393836', '#77746e'], bleu: ['#53709a', '#a9c0dd'], jaune: ['#c79843', '#f2d79a'], orange: ['#ad522e', '#e9a07c'], rouge: ['#87292a', '#d0726a'] };
  var PLAN = { blanc: ['#e6dece', false], gris: ['#aeada9', false], noir: ['#3b3a38', true], bleu: ['#53709a', true], jaune: ['#c99a45', false], orange: ['#ad522e', true], rouge: ['#87292a', true] };
  var ROOMS = {
    lin: { wall: '#ebe6dc', floor: 'woodLight', rug: '#e3dccf', sky: '#f4efe6' },
    sauge: { wall: '#c7cdbb', floor: 'woodLight', rug: '#ece4d6', sky: '#eef0e8' },
    argile: { wall: '#d7b49b', floor: 'woodLight', rug: '#efe5d6', sky: '#f3e8de' },
    nuit: { wall: '#39404c', floor: 'woodDark', rug: '#8f877b', sky: '#d9dde6' }
  };
  var COLORS = DATA.colors || [];
  var CB = {};
  COLORS.forEach(function (c) { CB[c.id] = c; });
  var MOD = DATA.modules || {};

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nid = 100;
  var state = { view: '3d', room: ROOMS[DATA.room] ? DATA.room : 'lin', noWebgl: false, color: CB[DATA.color] ? DATA.color : 'orange', sel: -1, mods: [] };

  // ---------- données ----------
  function size(t) { var m = MOD[t] || {}; return [m.w || 1, m.d || 1]; }
  function fp(m) { var s = size(m.type); return m.r % 2 ? [s[1], s[0]] : [s[0], s[1]]; }
  function variant(t, c) { var m = MOD[t]; return m && m.variants ? m.variants[c] : null; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function fmt(cents) {
    var e = Math.floor(cents / 100), c = cents % 100;
    var s = String(e).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return s + (c ? ',' + (c < 10 ? '0' : '') + c : '') + ' €';
  }
  function findMod(id) { for (var i = 0; i < state.mods.length; i++) if (state.mods[i].id === id) return state.mods[i]; return null; }

  function layoutChain(types, color) {
    var D = size('angle')[1];
    var out = [];
    var x = 0, z = 0, dir = 0, seg = null; // dir : 0=E 1=S 2=W 3=N
    types.forEach(function (t) {
      if (!MOD[t] || t === 'pouf') return;
      if (t === 'angle') {
        var x0, z0;
        if (dir === 0) { x0 = x; z0 = z; z += D; }
        else if (dir === 1) { x0 = x; z0 = z; }
        else if (dir === 2) { x0 = x - D; z0 = z; x -= D; }
        else { x0 = x; z0 = z - D; x += D; z -= D; }
        out.push({ type: t, x: x0 + D / 2, z: z0 + D / 2, r: dir });
        dir = (dir + 1) % 4; if (seg) seg.done = true; return;
      }
      var L = size(t)[0], SD = size(t)[1], w, d;
      if (dir === 0) { x0 = x; z0 = z; w = L; d = SD; x += L; }
      else if (dir === 1) { x0 = x; z0 = z; w = SD; d = L; z += L; }
      else if (dir === 2) { x0 = x - L; z0 = z; w = L; d = SD; x -= L; }
      else { x0 = x; z0 = z - L; w = SD; d = L; z -= L; }
      if (dir === 0) { if (!seg) seg = { x0: x0, x1: x0 + w, z1: z0 + SD }; else if (!seg.done) seg.x1 = x0 + w; }
      out.push({ type: t, x: x0 + w / 2, z: z0 + d / 2, r: dir });
    });
    var pf = types.filter(function (t) { return t === 'pouf'; });
    if (pf.length && MOD.pouf) {
      var P = size('pouf')[0], PD = size('pouf')[1], gap = 0.25, rowW = pf.length * P + (pf.length - 1) * gap;
      var s = seg || { x0: 0, x1: rowW, z1: 0 };
      var cx = (s.x0 + s.x1) / 2;
      pf.forEach(function (t, k) { out.push({ type: 'pouf', x: cx - rowW / 2 + P / 2 + k * (P + gap), z: s.z1 + 0.75 + PD / 2, r: 0 }); });
    }
    if (!out.length) return [];
    var minX = Infinity, maxX = -Infinity, minZ = Infinity;
    out.forEach(function (m) { var f = fp(m); minX = Math.min(minX, m.x - f[0] / 2); maxX = Math.max(maxX, m.x + f[0] / 2); minZ = Math.min(minZ, m.z - f[1] / 2); });
    var dx = RW / 2 + 0.25 - (minX + maxX) / 2, dz = 0.12 - minZ;
    return out.map(function (m) { return { id: ++nid, type: m.type, color: color, x: +(m.x + dx).toFixed(3), z: +(m.z + dz).toFixed(3), r: m.r }; });
  }

  function snapPos(id, type, r, x, z) {
    var f = fp({ type: type, r: r });
    var hw = f[0] / 2, hd = f[1] / 2, M = 0.14;
    var bx = null, bz = null, bdx = M, bdz = M;
    state.mods.forEach(function (o) {
      if (o.id === id) return;
      var g = fp(o), ohw = g[0] / 2, ohd = g[1] / 2;
      [[x - hw, o.x + ohw, hw], [x + hw, o.x - ohw, -hw], [x - hw, o.x - ohw, hw], [x + hw, o.x + ohw, -hw]].forEach(function (a) { var dd = Math.abs(a[0] - a[1]); if (dd < bdx) { bdx = dd; bx = a[1] + a[2]; } });
      [[z - hd, o.z + ohd, hd], [z + hd, o.z - ohd, -hd], [z - hd, o.z - ohd, hd], [z + hd, o.z + ohd, -hd]].forEach(function (a) { var dd = Math.abs(a[0] - a[1]); if (dd < bdz) { bdz = dd; bz = a[1] + a[2]; } });
    });
    if (bx === null) bx = Math.round(x / 0.05) * 0.05;
    if (bz === null) bz = Math.round(z / 0.05) * 0.05;
    bx = Math.min(RW - hw, Math.max(hw + 0.02, bx));
    bz = Math.min(RD - hd, Math.max(hd + 0.02, bz));
    return [+bx.toFixed(3), +bz.toFixed(3)];
  }

  function freeSpot(type) {
    var f = size(type);
    var overlaps = function (x, z) { return state.mods.some(function (o) { var g = fp(o); return Math.abs(o.x - x) < (g[0] + f[0]) / 2 - 0.01 && Math.abs(o.z - z) < (g[1] + f[1]) / 2 - 0.01; }); };
    for (var zz = RD - f[1] / 2 - 0.3; zz > f[1] / 2; zz -= 0.25) {
      for (var k = 0; k < 24; k++) {
        var xx = RW / 2 + (k % 2 ? 1 : -1) * Math.ceil(k / 2) * 0.25;
        if (xx - f[0] / 2 < 0.05 || xx + f[0] / 2 > RW - 0.05) continue;
        if (!overlaps(xx, zz)) return [xx, zz];
      }
    }
    return [RW / 2, RD - f[1] / 2 - 0.2];
  }

  function setState(patch) {
    for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) state[k] = patch[k];
    render();
  }

  // ---------- actions ----------
  function selMod() { return findMod(state.sel); }
  function activeColor() { var s = selMod(); return s ? s.color : state.color; }
  function addModule(t) {
    var p = freeSpot(t), id = ++nid;
    setState({ mods: state.mods.concat([{ id: id, type: t, color: activeColor(), x: +p[0].toFixed(3), z: +p[1].toFixed(3), r: 0 }]), sel: id });
  }
  function rotateSel() {
    var m = selMod(); if (!m) return;
    var r = (m.r + 1) % 4, s = snapPos(m.id, m.type, r, m.x, m.z);
    setState({ mods: state.mods.map(function (q) { return q.id === m.id ? Object.assign({}, q, { r: r, x: s[0], z: s[1] }) : q; }) });
  }
  function dupSel() {
    var m = selMod(); if (!m) return;
    var p = freeSpot(m.type), id = ++nid;
    setState({ mods: state.mods.concat([Object.assign({}, m, { id: id, x: +p[0].toFixed(3), z: +p[1].toFixed(3) })]), sel: id });
  }
  function removeSel() { var m = selMod(); if (!m) return; setState({ mods: state.mods.filter(function (q) { return q.id !== m.id; }), sel: -1 }); }
  function moveSel(dx, dz) {
    var m = selMod(); if (!m) return;
    var f = fp(m);
    var x = Math.min(RW - f[0] / 2, Math.max(f[0] / 2 + 0.02, m.x + dx)), z = Math.min(RD - f[1] / 2, Math.max(f[1] / 2 + 0.02, m.z + dz));
    setState({ mods: state.mods.map(function (q) { return q.id === m.id ? Object.assign({}, q, { x: +x.toFixed(3), z: +z.toFixed(3) }) : q; }) });
  }
  function pickColor(c) {
    var m = selMod();
    if (m) setState({ color: c, mods: state.mods.map(function (q) { return q.id === m.id ? Object.assign({}, q, { color: c }) : q; }) });
    else setState({ color: c, mods: state.mods.map(function (q) { return Object.assign({}, q, { color: c }); }) });
  }
  function applyPreset(str) {
    var types = String(str || '').split(',').map(function (s) { return s.trim(); }).filter(function (t) { return MOD[t]; });
    setState({ sel: -1, mods: layoutChain(types, state.color) });
  }

  // ---------- rendu de l'interface ----------
  var el = {
    studio: $('[data-cfg-studio]'), canvas: $('[data-cfg-canvas]'), nogl: $('[data-cfg-nogl]'), plan: $('[data-cfg-plan]'),
    selbar: $('[data-cfg-selbar]'), selname: $('[data-cfg-selname]'), walls: $('[data-cfg-walls]'), pal: $('[data-cfg-pal]'),
    catalog: $('[data-cfg-catalog]'), catalogM: $('[data-cfg-catalog-m]'), target: $('[data-cfg-target]'), swatches: $('[data-cfg-swatches]'),
    applyall: $('[data-cfg-applyall]'), hint: $('[data-cfg-hint]'), lineup: $('[data-cfg-lineup]'), empty: $('[data-cfg-empty]'),
    lines: $('[data-cfg-lines]'), total: $('[data-cfg-total]'), compare: $('[data-cfg-compare]'), unavail: $('[data-cfg-unavail]'),
    atc: $('[data-cfg-atc]'), msg: $('[data-cfg-msg]')
  };

  function thumb(t, c) { var v = variant(t, c); return v && v.img ? v.img : ''; }

  function renderCatalog() {
    var ac = activeColor();
    var html = '', mhtml = '';
    TYPES.forEach(function (t) {
      if (!MOD[t]) return;
      var v = variant(t, ac), name = MOD[t].name;
      var price = v ? (v.available ? fmt(v.price) : (TX.unavailable || 'Indisponible')) : (TX.unavailable || 'Indisponible');
      var img = thumb(t, ac);
      html += '<button type="button" class="cfg-cat" data-act="add" data-t="' + t + '" aria-label="' + esc((TX.addAria || 'Ajouter :') + ' ' + name) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="cfg-cat__ph"></span>') +
        '<span class="cfg-cat__txt"><span class="cfg-cat__n">' + esc(name) + '</span><span class="cfg-cat__p">' + esc(price) + '</span></span></button>';
      mhtml += '<button type="button" class="cfg-ghost cfg-ghost--m" data-act="add" data-t="' + t + '" aria-label="' + esc((TX.addAria || 'Ajouter :') + ' ' + name) + '">+ ' + esc(MOD[t].short || name) + '</button>';
    });
    el.catalog.innerHTML = html;
    el.catalogM.innerHTML = mhtml;
  }

  function renderSwatches() {
    var ac = activeColor(), m = selMod();
    el.swatches.innerHTML = COLORS.map(function (c) {
      var on = c.id === ac;
      return '<button type="button" class="cfg-sw' + (on ? ' is-on' : '') + '" data-act="color" data-c="' + c.id + '" aria-pressed="' + on + '" aria-label="Coloris ' + esc(c.name) + '" title="' + esc(c.name) + '">' +
        (c.img ? '<img src="' + esc(c.img) + '" alt="" width="30" height="30">' : '<span style="background:' + PLAN[c.id][0] + '"></span>') + '</button>';
    }).join('');
    el.target.textContent = (m ? (TX.targetModule || 'Coloris du module ·') : (TX.targetAll || 'Coloris de tout le canapé ·')) + ' ' + (CB[ac] ? CB[ac].name : '');
    el.applyall.hidden = !m;
  }

  function renderPlan() {
    if (state.view !== 'plan') { el.plan.hidden = true; return; }
    el.plan.hidden = false;
    var vb = '-0.35 -0.35 ' + (RW + 0.7) + ' ' + (RD + 0.7);
    var s = '<svg viewBox="' + vb + '" role="img" aria-label="' + esc(TX.planAria || '') + '" data-plan-svg>';
    s += '<rect x="0" y="0" width="' + RW + '" height="' + RD + '" fill="#ffffff" stroke="#dcd8cf" stroke-width="0.02"/>';
    s += '<rect x="' + (RW / 2 + 0.25 - 1.7) + '" y="0.6" width="3.4" height="2.5" rx="0.04" fill="#efebe3"/>';
    s += '<line x1="0" y1="0" x2="' + RW + '" y2="0" stroke="#201e18" stroke-width="0.08"/><line x1="0" y1="0" x2="0" y2="' + RD + '" stroke="#201e18" stroke-width="0.08"/>';
    s += '<line x1="0" y1="1.6" x2="0" y2="3.2" stroke="#9fc3dd" stroke-width="0.1"/>';
    s += '<circle cx="0.45" cy="0.35" r="0.18" fill="#ffffff" stroke="#b08d57" stroke-width="0.02"/><circle cx="' + (RW - 0.4) + '" cy="0.38" r="0.22" fill="#7c9a6e"/>';
    state.mods.forEach(function (m) {
      var f = fp(m), c = PLAN[m.color] || PLAN.blanc;
      var x = m.x - f[0] / 2, y = m.z - f[1] / 2, t = 0.24, sel = m.id === state.sel;
      var backs = (m.type === 'pouf' ? [] : m.type === 'angle' ? [0, 1] : [0]).map(function (k) { return (k + m.r) % 4; });
      var band = c[1] ? 'rgba(255,255,255,.16)' : 'rgba(32,30,24,.14)', ink = c[1] ? '#ffffff' : '#201e18';
      s += '<g data-pid="' + m.id + '" style="cursor:grab">';
      s += '<rect x="' + x + '" y="' + y + '" width="' + f[0] + '" height="' + f[1] + '" rx="0.09" fill="' + c[0] + '" stroke="' + (sel ? '#201e18' : 'rgba(32,30,24,.18)') + '" stroke-width="' + (sel ? 0.04 : 0.012) + '"/>';
      backs.forEach(function (b) {
        var r = b === 0 ? [x, y, f[0], t] : b === 1 ? [x + f[0] - t, y, t, f[1]] : b === 2 ? [x, y + f[1] - t, f[0], t] : [x, y, t, f[1]];
        s += '<rect x="' + r[0] + '" y="' + r[1] + '" width="' + r[2] + '" height="' + r[3] + '" rx="0.07" fill="' + band + '"/>';
      });
      s += '<text x="' + m.x + '" y="' + m.z + '" text-anchor="middle" dominant-baseline="middle" font-size="0.13" font-weight="600" fill="' + ink + '" style="pointer-events:none;font-family:\'General Sans\',system-ui,sans-serif">' + esc(MOD[m.type] ? MOD[m.type].short : '') + '</text></g>';
    });
    s += '</svg>';
    el.plan.innerHTML = s;
  }

  function renderBelow() {
    // Vos modules
    el.lineup.innerHTML = state.mods.map(function (m) {
      var img = thumb(m.type, m.color), name = MOD[m.type] ? MOD[m.type].name : '', cn = CB[m.color] ? CB[m.color].name : '';
      return '<figure class="cfg-lu">' + (img ? '<img src="' + esc(img) + '" alt="' + esc('Goto ' + name.toLowerCase() + ', coloris ' + cn.toLowerCase()) + '" loading="lazy" width="400" height="400">' : '<span class="cfg-lu__ph"></span>') +
        '<figcaption><b>' + esc(name) + '</b><span>' + esc(cn) + '</span></figcaption></figure>';
    }).join('');
    // Récapitulatif (groupé par module + coloris)
    var groups = {}, keys = [], total = 0, compare = 0, missing = false;
    state.mods.forEach(function (m) { var k = m.type + '|' + m.color; if (!groups[k]) { groups[k] = { type: m.type, color: m.color, n: 0 }; keys.push(k); } groups[k].n += 1; });
    el.lines.innerHTML = keys.map(function (k) {
      var g = groups[k], v = variant(g.type, g.color), ok = v && v.available;
      var label = (g.n > 1 ? g.n + ' × ' : '') + (MOD[g.type] ? MOD[g.type].name : '') + ' · ' + (CB[g.color] ? CB[g.color].name : '');
      if (ok) { total += v.price * g.n; compare += (v.compare > v.price ? v.compare : v.price) * g.n; } else missing = true;
      return '<div class="cfg-line' + (ok ? '' : ' is-off') + '"><span>' + esc(label) + '</span><span>' + (ok ? fmt(v.price * g.n) : esc(TX.unavailable || 'Indisponible')) + '</span></div>';
    }).join('');
    el.empty.hidden = state.mods.length > 0;
    el.total.textContent = fmt(total);
    el.compare.hidden = !(compare > total);
    el.compare.textContent = compare > total ? fmt(compare) : '';
    el.unavail.hidden = !missing;
    el.unavail.textContent = missing ? (TX.unavailNote || '') : '';
  }

  function render() {
    var m = selMod();
    root.querySelectorAll('[data-act="view"]').forEach(function (b) { var on = b.getAttribute('data-v') === state.view; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    root.querySelectorAll('[data-act="room"]').forEach(function (b) { var on = b.getAttribute('data-room') === state.room; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    el.walls.hidden = state.view !== '3d' || state.noWebgl;
    el.selbar.hidden = !m;
    if (m) el.selname.innerHTML = MOD[m.type] ? '<span class="cfg-n-l">' + esc(MOD[m.type].name) + '</span><span class="cfg-n-s">' + esc(MOD[m.type].short || MOD[m.type].name) + '</span>' : '';
    el.canvas.hidden = state.view !== '3d';
    el.nogl.hidden = !(state.view === '3d' && state.noWebgl);
    el.hint.textContent = state.view === '3d' ? (TX.hint3d || '') : (TX.hintPlan || '');
    renderCatalog(); renderSwatches(); renderPlan(); renderBelow();
    sync3d();
    if (state.view === '3d') start3d();
    updateLoop();
  }

  // ---------- événements ----------
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b || !root.contains(b)) return;
    var a = b.getAttribute('data-act');
    if (a === 'view') setState({ view: b.getAttribute('data-v') });
    else if (a === 'room') setState({ room: b.getAttribute('data-room') });
    else if (a === 'add') addModule(b.getAttribute('data-t'));
    else if (a === 'color') pickColor(b.getAttribute('data-c'));
    else if (a === 'applyall') { var ac = activeColor(); setState({ color: ac, mods: state.mods.map(function (q) { return Object.assign({}, q, { color: ac }); }) }); }
    else if (a === 'rotate') rotateSel();
    else if (a === 'dup') dupSel();
    else if (a === 'remove') removeSel();
    else if (a === 'deselect') setState({ sel: -1 });
    else if (a === 'preset') applyPreset(b.getAttribute('data-types'));
    else if (a === 'atc') addToCart();
  });

  // Clavier : seulement quand le studio (ou un de ses boutons) a le focus.
  el.studio.addEventListener('keydown', function (e) {
    if (!selMod()) return;
    var t = e.target;
    if (t && t.tagName === 'BUTTON' && (e.key === 'Enter' || e.key === ' ')) return;
    var st = e.shiftKey ? 0.25 : 0.05, k = e.key;
    if (k === 'ArrowLeft') moveSel(-st, 0);
    else if (k === 'ArrowRight') moveSel(st, 0);
    else if (k === 'ArrowUp') moveSel(0, -st);
    else if (k === 'ArrowDown') moveSel(0, st);
    else if (k === 'r' || k === 'R') rotateSel();
    else if (k === 'Delete' || k === 'Backspace') removeSel();
    else if (k === 'Escape') setState({ sel: -1 });
    else return;
    e.preventDefault();
  });

  // Vue de dessus : glisser-déposer au pointeur
  var pdrag = null;
  function svgPt(svg, e) { var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY; return pt.matrixTransform(svg.getScreenCTM().inverse()); }
  el.plan.addEventListener('pointerdown', function (e) {
    var svg = el.plan.querySelector('svg'); if (!svg) return;
    var g = e.target.closest('[data-pid]');
    if (!g) { if (state.sel !== -1) setState({ sel: -1 }); return; }
    var m = findMod(+g.getAttribute('data-pid')); if (!m) return;
    var p = svgPt(svg, e);
    pdrag = { id: m.id, ox: p.x - m.x, oz: p.y - m.z, pointer: e.pointerId };
    try { el.plan.setPointerCapture(e.pointerId); } catch (er) {}
    e.preventDefault();
    if (state.sel !== m.id) setState({ sel: m.id });
  });
  el.plan.addEventListener('pointermove', function (e) {
    if (!pdrag) return;
    var svg = el.plan.querySelector('svg'), m = findMod(pdrag.id); if (!svg || !m) return;
    var p = svgPt(svg, e), s = snapPos(m.id, m.type, m.r, p.x - pdrag.ox, p.y - pdrag.oz);
    if (s[0] === m.x && s[1] === m.z) return;
    state.mods = state.mods.map(function (q) { return q.id === m.id ? Object.assign({}, q, { x: s[0], z: s[1] }) : q; });
    renderPlan();
  });
  var planUp = function () { if (pdrag) { pdrag = null; render(); } };
  el.plan.addEventListener('pointerup', planUp);
  el.plan.addEventListener('pointercancel', planUp);

  // ---------- panier ----------
  function addToCart() {
    if (!state.mods.length) { el.msg.textContent = TX.emptyAtc || ''; return; }
    var qty = {}, order = [], skipped = [];
    state.mods.forEach(function (m) {
      var v = variant(m.type, m.color);
      if (!v || !v.available) { skipped.push(m); return; }
      if (!qty[v.id]) { qty[v.id] = 0; order.push(v.id); }
      qty[v.id] += 1;
    });
    if (!order.length) { var s0 = skipped[0]; el.msg.textContent = (TX.errorItem || '').replace('{m}', (MOD[s0.type] ? MOD[s0.type].name : '') + ' ' + (CB[s0.color] ? CB[s0.color].name : '')); return; }
    var tag = 'OHUME-' + Date.now();
    var items = order.map(function (id) { return { id: id, quantity: qty[id], properties: { _composition: tag } }; });
    el.atc.disabled = true; el.atc.setAttribute('aria-busy', 'true');
    el.msg.textContent = TX.adding || '';
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (!res.ok) {
        var d = (res.j && (res.j.description || res.j.message)) || '';
        el.msg.textContent = (TX.errorGeneric || '') + (d ? ' (' + d + ')' : '');
        return;
      }
      el.msg.textContent = TX.added || '';
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') setTimeout(function () { drawer.show(); }, 350);
    }).catch(function () { el.msg.textContent = TX.errorGeneric || ''; })
      .then(function () { el.atc.disabled = false; el.atc.removeAttribute('aria-busy'); });
  }

  // ---------- 3D ----------
  var g3 = null, libsState = 0, inView = false;
  function loadLibs(cb) {
    if (window.THREE && window.THREE.OrbitControls) { cb(); return; }
    if (libsState === 1) { loadLibs.q.push(cb); return; }
    libsState = 1; loadLibs.q = [cb];
    var s = document.createElement('script');
    s.src = DATA.libs; s.async = true;
    s.onload = function () { libsState = 2; loadLibs.q.forEach(function (f) { f(); }); };
    s.onerror = function () { libsState = 3; setState({ noWebgl: true, view: 'plan' }); };
    document.head.appendChild(s);
  }
  function start3d() {
    if (g3 || state.noWebgl || !inView || libsState === 3) return;
    loadLibs(function () { if (!g3) init3d(); });
  }

  function init3d() {
    var T = window.THREE;
    if (!T || !T.OrbitControls || g3) return;
    var cv = el.canvas, renderer;
    try { renderer = new T.WebGLRenderer({ canvas: cv, antialias: true }); }
    catch (e) { setState({ noWebgl: true, view: 'plan' }); return; }
    if (!renderer.getContext()) { setState({ noWebgl: true, view: 'plan' }); return; }
    renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = T.PCFSoftShadowMap;
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.08;
    var scene = new T.Scene();
    var camera = new T.PerspectiveCamera(34, 1, 0.1, 80);
    var controls = new T.OrbitControls(camera, cv);
    controls.enableDamping = !reduceMotion; controls.dampingFactor = 0.08; controls.enablePan = false;
    controls.minPolarAngle = 0.25; controls.maxPolarAngle = 1.42;
    controls.minDistance = 3; controls.maxDistance = 14;
    controls.minAzimuthAngle = -1.2; controls.maxAzimuthAngle = 1.4;
    var g = { T: T, renderer: renderer, scene: scene, camera: camera, controls: controls, geo: {}, mats: {}, groups: {}, roomKey: '', modKey: '', running: false };
    g3 = g;
    g.tex = makeTextures(T, renderer);
    var resize = function () {
      var w = cv.clientWidth || 800, h = cv.clientHeight || 500;
      renderer.setSize(w, h, false); camera.aspect = w / h;
      // Sur téléphone (cadre étroit), on recule un peu la caméra pour voir toute la pièce.
      camera.fov = w < 560 ? 46 : 34;
      camera.updateProjectionMatrix();
      g.dirty = true;
    };
    g.resize = resize;
    if (window.ResizeObserver) { g.ro = new ResizeObserver(resize); g.ro.observe(cv); }
    resize();
    controls.target.set(RW / 2, 0.35, RD / 2 - 0.2);
    var dv = new T.Vector3(0.42, 0.62, 1).normalize();
    camera.position.set(RW / 2 + dv.x * 7.6, 0.35 + dv.y * 7.6, RD / 2 - 0.2 + dv.z * 7.6);
    controls.update();
    controls.addEventListener('change', function () { g.dirty = true; });

    var ray = new T.Raycaster();
    var floor = new T.Plane(new T.Vector3(0, 1, 0), 0);
    var ndc = function (e) { var r = cv.getBoundingClientRect(); return new T.Vector2(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1); };
    var floorAt = function (e) { ray.setFromCamera(ndc(e), camera); var p = new T.Vector3(); return ray.ray.intersectPlane(floor, p) ? p : null; };
    var down = null;
    g.onDown = function (e) {
      down = { x: e.clientX, y: e.clientY, moved: false };
      // Positions à jour même si l'image suivante n'est pas encore dessinée (modules reconstruits juste avant).
      scene.updateMatrixWorld(); camera.updateMatrixWorld();
      ray.setFromCamera(ndc(e), camera);
      var list = Object.keys(g.groups).map(function (k) { return g.groups[k]; });
      var hits = ray.intersectObjects(list, true);
      if (hits.length) {
        var o = hits[0].object;
        while (o && o.userData.id === undefined) o = o.parent;
        if (o) {
          var m = findMod(o.userData.id), p = floorAt(e);
          if (m && p) {
            down.drag = { id: m.id, type: m.type, r: m.r, ox: p.x - m.x, oz: p.z - m.z, x: m.x, z: m.z };
            controls.enabled = false;
            if (cv.setPointerCapture) try { cv.setPointerCapture(e.pointerId); } catch (er) {}
            if (state.sel !== m.id) setState({ sel: m.id });
          }
        }
      }
      cv.style.cursor = 'grabbing';
    };
    g.onMove = function (e) {
      if (!down) return;
      if (Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y) > 4) down.moved = true;
      if (!down.drag || !down.moved) return;
      var p = floorAt(e); if (!p) return;
      var d = down.drag, s = snapPos(d.id, d.type, d.r, p.x - d.ox, p.z - d.oz);
      d.x = s[0]; d.z = s[1];
      var grp = g.groups[d.id];
      if (grp) { grp.position.x = d.x; grp.position.z = d.z; }
      if (g.halo) { g.halo.position.x = d.x; g.halo.position.z = d.z; }
      g.dirty = true;
    };
    g.onUp = function () {
      cv.style.cursor = 'grab';
      controls.enabled = true;
      if (!down) return;
      var d = down.drag, moved = down.moved;
      down = null;
      if (d && moved) setState({ mods: state.mods.map(function (m) { return m.id === d.id ? Object.assign({}, m, { x: d.x, z: d.z }) : m; }) });
      else if (!d && !moved && state.sel !== -1) setState({ sel: -1 });
    };
    cv.addEventListener('pointerdown', g.onDown);
    cv.addEventListener('pointermove', g.onMove);
    cv.addEventListener('pointerup', g.onUp);
    cv.addEventListener('pointercancel', g.onUp);
    sync3d();
    updateLoop();
  }

  function frame() {
    var g = g3;
    if (!g || !g.running) return;
    var changed = g.controls.update();
    if (changed || g.dirty || g.frames > 0) { g.renderer.render(g.scene, g.camera); g.dirty = false; if (g.frames > 0) g.frames--; }
    g.raf = requestAnimationFrame(frame);
  }
  function updateLoop() {
    var g = g3; if (!g) return;
    var should = inView && state.view === '3d' && !document.hidden;
    if (should && !g.running) { g.running = true; g.dirty = true; g.frames = 2; g.raf = requestAnimationFrame(frame); }
    else if (!should && g.running) { g.running = false; cancelAnimationFrame(g.raf); }
  }

  function clearGroup(grp) {
    if (!grp) return;
    grp.traverse(function (o) { if (o.geometry && !o.geometry.userData.cached) o.geometry.dispose(); });
    if (grp.parent) grp.parent.remove(grp);
  }

  function makeTextures(T, renderer) {
    var aniso = renderer.capabilities.getMaxAnisotropy();
    var mk = function (w, h, draw, rx, ry, srgb) {
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      draw(c.getContext('2d'), w, h);
      var t = new T.CanvasTexture(c);
      t.wrapS = t.wrapT = T.RepeatWrapping; t.repeat.set(rx, ry); t.anisotropy = aniso;
      if (srgb) t.encoding = T.sRGBEncoding;
      return t;
    };
    var seed = 7;
    var rnd = function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
    var cord = mk(64, 64, function (x, w, h) {
      x.fillStyle = '#808080'; x.fillRect(0, 0, w, h);
      for (var i = 0; i < w; i += 4) { x.fillStyle = '#d0d0d0'; x.fillRect(i, 0, 2, h); x.fillStyle = '#5a5a5a'; x.fillRect(i + 3, 0, 1, h); }
    }, 5, 5, false);
    var wood = function (base) {
      return mk(1024, 1024, function (x, w, h) {
        var rows = 8, ph = h / rows;
        for (var r = 0; r < rows; r++) {
          var xo = -rnd() * 400;
          while (xo < w) {
            var len = 380 + rnd() * 420, k = 0.86 + rnd() * 0.22;
            var c = base.map(function (v) { return Math.max(0, Math.min(255, Math.round(v * k))); });
            x.fillStyle = 'rgb(' + c.join(',') + ')';
            x.fillRect(xo, r * ph, len, ph);
            x.globalAlpha = 0.08;
            for (var gl = 0; gl < 14; gl++) { x.fillStyle = rnd() > 0.5 ? '#000' : '#fff'; x.fillRect(xo, r * ph + rnd() * ph, len, 1 + rnd() * 2); }
            x.globalAlpha = 1;
            x.fillStyle = 'rgba(0,0,0,.22)'; x.fillRect(xo, r * ph, 2, ph);
            xo += len;
          }
          x.fillStyle = 'rgba(0,0,0,.25)'; x.fillRect(0, r * ph, w, 2);
        }
      }, 5, 5, true);
    };
    var art = mk(600, 440, function (x, w, h) {
      x.fillStyle = '#efe7da'; x.fillRect(0, 0, w, h);
      x.fillStyle = '#b4532a'; x.beginPath(); x.arc(w * 0.38, h * 0.62, h * 0.34, Math.PI, 0); x.fill();
      x.fillStyle = '#f1e3b8'; x.beginPath(); x.arc(w * 0.66, h * 0.36, h * 0.17, 0, Math.PI * 2); x.fill();
      x.fillStyle = '#1b1a17'; x.fillRect(w * 0.12, h * 0.62, w * 0.76, 3);
    }, 1, 1, true);
    var rug = mk(256, 256, function (x, w, h) {
      x.fillStyle = '#ffffff'; x.fillRect(0, 0, w, h);
      x.globalAlpha = 0.07;
      for (var i = 0; i < 2600; i++) { x.fillStyle = rnd() > 0.5 ? '#000' : '#fff'; x.fillRect(rnd() * w, rnd() * h, 2, 2); }
      x.globalAlpha = 1;
    }, 6, 6, true);
    return { cord: cord, art: art, rug: rug, woodLight: wood([206, 168, 124]), woodDark: wood([108, 80, 58]) };
  }

  // Forme du Goto (reprise à l'identique de la maquette) : une silhouette de profil (z = profondeur, dossier en -z ; y = hauteur)
  // balayée sur la largeur x, avec plis, extrémités arrondies et « oreilles » en haut du dossier.
  function gotoGeo(T, W, kind) {
    // [z, y, plis, oreille, pincement avant]
    var PROF = {
      seat: [
        [0.47, 0.0, 0, 0, 0], [0.515, 0.08, 0.004, 0, 0], [0.53, 0.2, 0.004, 0, 0.5], [0.5, 0.3, 0.003, 0, 1], [0.39, 0.37, 0.0, 0, 0.6],
        [0.14, 0.38, 0.0, 0, 0], [-0.06, 0.375, 0.012, 0, 0], [-0.17, 0.4, 0.024, 0, 0], [-0.24, 0.48, 0.022, 0, 0], [-0.285, 0.59, 0.01, 0.4, 0],
        [-0.335, 0.68, 0.003, 1, 0], [-0.42, 0.725, 0.0, 1, 0], [-0.5, 0.67, 0.002, 1, 0], [-0.535, 0.52, 0.002, 0.3, 0], [-0.535, 0.3, 0.002, 0, 0],
        [-0.515, 0.1, 0.002, 0, 0], [-0.46, 0.0, 0, 0, 0], [0.0, 0.0, 0, 0, 0]
      ],
      back: [
        [-0.17, 0.0, 0, 0, 0], [-0.15, 0.36, 0.01, 0, 0], [-0.19, 0.42, 0.022, 0, 0], [-0.245, 0.5, 0.02, 0, 0], [-0.285, 0.59, 0.01, 0.4, 0],
        [-0.335, 0.68, 0.003, 1, 0], [-0.42, 0.725, 0.0, 1, 0], [-0.5, 0.67, 0.002, 1, 0], [-0.535, 0.52, 0.002, 0.3, 0], [-0.535, 0.3, 0.002, 0, 0],
        [-0.515, 0.1, 0.002, 0, 0], [-0.46, 0.0, 0, 0, 0], [-0.3, 0.0, 0, 0, 0]
      ],
      pouf: [
        [0.4, 0.0, 0, 0, 0], [0.445, 0.08, 0.004, 0, 0], [0.455, 0.18, 0.004, 0, 0.4], [0.435, 0.29, 0.003, 0, 0.8], [0.34, 0.355, 0.0, 0, 0.3],
        [0.0, 0.365, 0.0, 0, 0], [-0.34, 0.355, 0.0, 0, 0.3], [-0.435, 0.29, 0.003, 0, 0.8], [-0.455, 0.18, 0.004, 0, 0.4], [-0.445, 0.08, 0.004, 0, 0],
        [-0.4, 0.0, 0, 0, 0], [0.0, 0.0, 0, 0, 0]
      ]
    };
    var cp = PROF[kind];
    var n = cp.length, SUB = 14;
    var pts = [];
    for (var i = 0; i < n; i++) {
      var p0 = cp[(i - 1 + n) % n], p1 = cp[i], p2 = cp[(i + 1) % n], p3 = cp[(i + 2) % n];
      for (var s = 0; s < SUB; s++) {
        var t = s / SUB, t2 = t * t, t3 = t2 * t;
        var cr = function (a, b, c, d) { return 0.5 * (2 * b + (-a + c) * t + (2 * a - 5 * b + 4 * c - d) * t2 + (-a + 3 * b - 3 * c + d) * t3); };
        pts.push({ z: cr(p0[0], p1[0], p2[0], p3[0]), y: Math.max(0, cr(p0[1], p1[1], p2[1], p3[1])), a: p1[2] + (p2[2] - p1[2]) * t, e: p1[3] + (p2[3] - p1[3]) * t, f: p1[4] + (p2[4] - p1[4]) * t });
      }
    }
    var N = pts.length;
    var area = 0, cz = 0, cy = 0, arc = 0;
    pts.forEach(function (p, i) { var q = pts[(i + 1) % N]; area += p.z * q.y - q.z * p.y; cz += p.z; cy += p.y; });
    cz /= N; cy /= N;
    var sign = area > 0 ? 1 : -1;
    pts.forEach(function (p, i) {
      var a = pts[(i - 1 + N) % N], b = pts[(i + 1) % N];
      var tz = b.z - a.z, ty = b.y - a.y, L = Math.hypot(tz, ty) || 1;
      p.nz = sign * ty / L; p.ny = -sign * tz / L;
      if (i > 0) arc += Math.hypot(p.z - pts[i - 1].z, p.y - pts[i - 1].y);
      p.s = arc;
    });
    var R = Math.min(0.17, W * 0.22), half = W / 2;
    var rings = [];
    var nb = Math.max(2, Math.ceil((W - 2 * R) / 0.035));
    var K = 12, k, th;
    for (k = K; k >= 1; k--) { th = (k / K) * Math.PI / 2; rings.push({ x: -(half - R + R * Math.sin(th)), sc: 0.1 + 0.9 * Math.cos(th) }); }
    for (var j = 0; j <= nb; j++) rings.push({ x: -(half - R) + (j / nb) * (W - 2 * R), sc: 1 });
    for (k = 1; k <= K; k++) { th = (k / K) * Math.PI / 2; rings.push({ x: half - R + R * Math.sin(th), sc: 0.1 + 0.9 * Math.cos(th) }); }
    var pos = [], uv = [], idx = [];
    var lam = 0.075;
    var nSeam = Math.max(1, Math.round(W / 0.44));
    rings.forEach(function (rg) {
      var ax = Math.abs(rg.x), sgn = rg.x < 0 ? -1 : 1;
      var lo = half - R - 0.2, hi = half - R * 0.3;
      var tE = Math.min(1, Math.max(0, (ax - lo) / (hi - lo)));
      var sm = tE * tE * (3 - 2 * tE);
      var close = rg.sc > 0.4 ? 1 : rg.sc / 0.4;
      var ear = kind === 'pouf' ? 0 : 0.1 * sm * close;
      var pinch = 0.05 * sm * close;
      var xr = Math.min(1, ax / half);
      var centre = 0.35 + 0.65 * (1 - xr * xr);
      var fold = rg.sc * rg.sc * rg.sc;
      var sp = W / nSeam;
      var dx = ((rg.x + half) % sp);
      dx = Math.min(dx, sp - dx);
      var vSeam = -0.005 * Math.exp(-(dx * dx) / (0.012 * 0.012));
      var bend = 0.07 * xr * xr;
      pts.forEach(function (p) {
        var wob = 1 + 0.3 * Math.sin(rg.x * 4.3 + p.s * 1.7);
        var pleat = p.a * 1.25 * centre * wob * fold * Math.cos((2 * Math.PI * (p.s + bend)) / lam);
        var hs = ((p.s % 0.21) + 0.21) % 0.21;
        var hd = Math.min(hs, 0.21 - hs);
        var hSeam = p.a < 0.008 ? -0.004 * Math.exp(-(hd * hd) / (0.01 * 0.01)) : 0;
        var crumple = 0.003 * Math.sin(rg.x * 9.0 + p.s * 7.0) * Math.sin(p.s * 13.0 - rg.x * 5.0);
        var d = pleat + crumple + (p.a < 0.012 ? (vSeam + hSeam) * fold : 0);
        var z = p.z + p.nz * d, y = p.y + p.ny * d;
        z = cz + (z - cz) * rg.sc; y = cy + (y - cy) * rg.sc;
        y += ear * p.e + pinch * p.f;
        z += pinch * p.f * 0.6 - ear * p.e * 0.25;
        var xo = rg.x + sgn * (ear * p.e * 0.25 + pinch * p.f * 0.3);
        pos.push(xo, Math.max(0, y), z);
        uv.push(rg.x * 2.2, p.s * 2.2);
      });
    });
    var R0 = rings.length;
    for (var r = 0; r < R0 - 1; r++) {
      for (i = 0; i < N; i++) {
        var a = r * N + i, b = r * N + ((i + 1) % N), c = (r + 1) * N + i, d2 = (r + 1) * N + ((i + 1) % N);
        if (sign > 0) idx.push(a, c, b, b, c, d2); else idx.push(a, b, c, b, d2, c);
      }
    }
    var capL = pos.length / 3; pos.push(-half, cy, cz); uv.push(0, 0);
    var capR = pos.length / 3; pos.push(half, cy, cz); uv.push(0, 0);
    for (i = 0; i < N; i++) {
      var i2 = (i + 1) % N, last = (R0 - 1) * N;
      if (sign > 0) { idx.push(capL, i2, i); idx.push(capR, last + i, last + i2); }
      else { idx.push(capL, i, i2); idx.push(capR, last + i2, last + i); }
    }
    var geo = new T.BufferGeometry();
    geo.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
    geo.setAttribute('uv', new T.Float32BufferAttribute(uv, 2));
    geo.setIndex(idx);
    geo.computeVertexNormals();
    return geo;
  }

  // Profondeur « native » des silhouettes de la maquette : la 3D est mise à l'échelle des profondeurs réglées.
  var NATIVE_D = { seat: 1.0, pouf: 0.91 };

  function geoFor(type) {
    var g = g3, T = g.T;
    if (!g.geo[type]) {
      var s = size(type);
      var geo = type === 'pouf' ? gotoGeo(T, s[0], 'pouf') : gotoGeo(T, s[0], 'seat');
      geo.userData.cached = true; g.geo[type] = geo;
      if (type === 'angle' && !g.geo.angleBack) { var b = gotoGeo(T, s[1], 'back'); b.userData.cached = true; g.geo.angleBack = b; }
    }
    return g.geo[type];
  }

  function matFor(color) {
    var g = g3, T = g.T;
    if (!g.mats[color]) {
      var F = FAB[color] || FAB.blanc;
      var c = function (h) { return new T.Color(h).convertSRGBToLinear(); };
      g.mats[color] = new T.MeshPhysicalMaterial({ color: c(F[0]), roughness: 0.88, metalness: 0, sheen: c(F[1]).multiplyScalar(0.32), bumpMap: g.tex.cord, bumpScale: 0.0022, side: T.DoubleSide });
    }
    return g.mats[color];
  }

  function buildMods() {
    var g = g3, T = g.T;
    clearGroup(g.modGrp);
    var rootG = new T.Group();
    g.modGrp = rootG; g.groups = {}; g.halo = null;
    g.scene.add(rootG);
    state.mods.forEach(function (m) {
      if (!MOD[m.type]) return;
      var grp = new T.Group();
      grp.userData.id = m.id;
      var mat = matFor(m.color), s = size(m.type);
      var mesh = function (geo) { var ms = new T.Mesh(geo, mat); ms.castShadow = true; ms.receiveShadow = true; return ms; };
      var main = mesh(geoFor(m.type));
      if (m.type === 'angle') {
        var side = mesh(g.geo.angleBack); side.rotation.y = -Math.PI / 2; grp.add(side);
        main.scale.z = s[1] / NATIVE_D.seat;
      } else {
        main.scale.z = s[1] / (m.type === 'pouf' ? NATIVE_D.pouf : NATIVE_D.seat);
      }
      grp.add(main);
      grp.rotation.y = -m.r * Math.PI / 2;
      grp.position.set(m.x, 0, m.z);
      rootG.add(grp);
      g.groups[m.id] = grp;
      if (m.id === state.sel) {
        var f = fp(m);
        var halo = new T.Mesh(new T.PlaneGeometry(f[0] + 0.26, f[1] + 0.26), new T.MeshBasicMaterial({ color: new T.Color('#201e18'), transparent: true, opacity: 0.38 }));
        halo.rotation.x = -Math.PI / 2;
        halo.position.set(m.x, 0.016, m.z);
        rootG.add(halo); g.halo = halo;
      }
    });
    g.dirty = true;
  }

  function buildRoom() {
    var g = g3, T = g.T;
    clearGroup(g.roomGrp);
    var rootG = new T.Group();
    g.roomGrp = rootG; g.scene.add(rootG);
    var R = ROOMS[state.room] || ROOMS.lin;
    var col = function (h) { return new T.Color(h).convertSRGBToLinear(); };
    var std = function (h, rough, extra) { return new T.MeshStandardMaterial(Object.assign({ color: col(h), roughness: rough, metalness: 0 }, extra || {})); };
    var add = function (m, cast) { m.receiveShadow = true; if (cast) m.castShadow = true; rootG.add(m); return m; };
    var floor = add(new T.Mesh(new T.PlaneGeometry(16, 14), std('#ffffff', 0.72, { map: g.tex[R.floor] })));
    floor.rotation.x = -Math.PI / 2; floor.position.set(8, 0, 7);
    var wallH = 2.75, wallMat = std(R.wall, 0.95);
    var bw = add(new T.Mesh(new T.PlaneGeometry(16, wallH), wallMat)); bw.position.set(8, wallH / 2, 0);
    var lw = add(new T.Mesh(new T.PlaneGeometry(14, wallH), wallMat)); lw.rotation.y = Math.PI / 2; lw.position.set(0, wallH / 2, 7);
    var sk = std(R.wall, 0.8);
    add(new T.Mesh(new T.BoxGeometry(16, 0.09, 0.02), sk)).position.set(8, 0.045, 0.01);
    add(new T.Mesh(new T.BoxGeometry(0.02, 0.09, 14), sk)).position.set(0.01, 0.045, 7);
    var glass = new T.Mesh(new T.PlaneGeometry(1.6, 1.9), new T.MeshBasicMaterial({ color: col(R.sky) }));
    glass.rotation.y = Math.PI / 2; glass.position.set(0.012, 1.3, 2.4); rootG.add(glass);
    var fm = std('#f6f2ea', 0.6);
    [[1.7, 0.06, 0, 0.95], [1.7, 0.06, 0, -0.95], [0.06, 1.9, 0.8, 0], [0.06, 1.9, -0.8, 0], [0.04, 1.9, 0, 0], [1.6, 0.04, 0, 0.25]].forEach(function (f) {
      var fr = new T.Mesh(new T.BoxGeometry(0.05, f[1], f[0]), fm); fr.position.set(0.03, 1.3 + f[3], 2.4 + f[2]); rootG.add(fr);
    });
    var af = add(new T.Mesh(new T.BoxGeometry(1.06, 0.8, 0.03), std('#201e18', 0.5)), true); af.position.set(RW / 2 + 0.25, 1.6, 0.016);
    var ap = add(new T.Mesh(new T.PlaneGeometry(0.98, 0.72), std('#ffffff', 0.9, { map: g.tex.art }))); ap.position.set(RW / 2 + 0.25, 1.6, 0.033);
    var rug = add(new T.Mesh(new T.BoxGeometry(3.4, 0.012, 2.5), std(R.rug, 1, { map: g.tex.rug }))); rug.position.set(RW / 2 + 0.25, 0.006, 1.85);
    var brass = std('#b08d57', 0.35, { metalness: 0.6 });
    var lamp = new T.Group();
    lamp.add(new T.Mesh(new T.CylinderGeometry(0.16, 0.18, 0.03, 32), brass)); lamp.children[0].position.y = 0.015;
    var pole = new T.Mesh(new T.CylinderGeometry(0.012, 0.012, 1.5, 12), brass); pole.position.y = 0.78; lamp.add(pole);
    var shade = new T.Mesh(new T.CylinderGeometry(0.17, 0.24, 0.3, 32, 1, true), new T.MeshStandardMaterial({ color: col('#f4ead8'), emissive: col('#ffdcae'), emissiveIntensity: 0.55, side: T.DoubleSide, roughness: 1 }));
    shade.position.y = 1.58; lamp.add(shade);
    lamp.traverse(function (o) { if (o.isMesh) o.castShadow = true; });
    lamp.position.set(0.45, 0, 0.35); rootG.add(lamp);
    var warm = new T.PointLight(col('#ffd8a8'), 0.5, 4.5, 2); warm.position.set(0.45, 1.5, 0.4); rootG.add(warm);
    var plant = new T.Group();
    var pot = new T.Mesh(new T.CylinderGeometry(0.2, 0.16, 0.42, 32), std('#d9d4ca', 0.85)); pot.position.y = 0.21; plant.add(pot);
    var leaf = std('#4f6b45', 0.8);
    for (var k = 0; k < 9; k++) {
      var l = new T.Mesh(new T.SphereGeometry(0.16, 16, 12), leaf);
      var a = k * 2.4, h = 0.6 + (k % 3) * 0.28;
      l.scale.set(0.55, 1.5, 0.22); l.position.set(Math.cos(a) * 0.14, h, Math.sin(a) * 0.14); l.rotation.set(Math.sin(a) * 0.5, a, Math.cos(a) * 0.5);
      plant.add(l);
    }
    plant.traverse(function (o) { if (o.isMesh) o.castShadow = true; });
    plant.position.set(RW - 0.4, 0, 0.38); rootG.add(plant);
    rootG.add(new T.HemisphereLight(col('#fff7ec'), col('#bfae98'), 0.5));
    var sun = new T.DirectionalLight(col('#fff3e2'), 1.4);
    sun.position.set(-2.5, 6, RD + 4); sun.target.position.set(RW / 2, 0, RD / 2); rootG.add(sun.target);
    sun.castShadow = true; sun.shadow.mapSize.set(2048, 2048);
    Object.assign(sun.shadow.camera, { left: -6, right: 6, top: 6, bottom: -6, near: 0.5, far: 25 });
    sun.shadow.bias = -0.0004; rootG.add(sun);
    var fill = new T.DirectionalLight(col('#e8eefc'), 0.28); fill.position.set(RW + 4, 3, RD + 3); rootG.add(fill);
    g.scene.background = col(R.wall);
    g.dirty = true;
  }

  function sync3d() {
    var g = g3; if (!g) return;
    if (g.roomKey !== state.room) { g.roomKey = state.room; buildRoom(); }
    var mk = JSON.stringify([state.mods, state.sel]);
    if (mk !== g.modKey) { g.modKey = mk; buildMods(); }
  }

  // Le studio ne démarre la 3D qu'à l'écran ; la boucle s'arrête quand il en sort (ou quand l'onglet est masqué).
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { inView = e.isIntersecting; });
      if (inView && state.view === '3d') start3d();
      updateLoop();
    }, { rootMargin: '200px 0px' }).observe(el.studio);
  } else { inView = true; }
  document.addEventListener('visibilitychange', updateLoop);

  // Diagnostic (uniquement avec ?cfgdebug=1 dans l'adresse) : position écran d'un module, pour les tests.
  if (/[?&]cfgdebug=1/.test(location.search)) {
    window.__cfg = {
      state: function () { return state; },
      screen: function (id) {
        var g = g3, m = findMod(id); if (!g || !m) return null;
        var v = new g.T.Vector3(m.x, 0.3, m.z).project(g.camera), r = el.canvas.getBoundingClientRect();
        return [r.left + (v.x + 1) / 2 * r.width, r.top + (1 - v.y) / 2 * r.height];
      }
    };
  }

  // ---------- démarrage ----------
  var startBtn = root.querySelectorAll('[data-act="preset"]')[(parseInt(DATA.preset, 10) || 2) - 1] || root.querySelector('[data-act="preset"]');
  state.mods = startBtn ? layoutChain(String(startBtn.getAttribute('data-types')).split(',').map(function (t) { return t.trim(); }), state.color) : [];
  render();
})();
